import React from "react";
import { Navigate, useNavigate } from "react-router";
import { useAuth } from "contexts/AuthProvider";
import { AuthHeader } from "@/components/authentication/common/AuthHeader";
import { ConsentForm } from "./ConsentForm";

export const ConsentPage = () => {
  const navigate = useNavigate();
  const { authenticated, loading, tosAccepted, tosAcceptedBefore, ppAccepted } =
    useAuth();

  if (loading) {
    return <div></div>;
  }

  if (!authenticated) {
    return <Navigate to="/" />;
  }

  if (tosAccepted && ppAccepted) {
    return <Navigate to="/overview" />;
  }

  return (
    <section className="auth-page">
      <div className="flex flex-col justify-center items-center min-h-full px-6 py-12 lg:px-8">
        <div className="w-full sm:max-w-sm flex flex-col gap-8">
          <AuthHeader
            title={tosAcceptedBefore ? "Updated Terms" : "Welcome to Mycorr"}
            message={
              tosAcceptedBefore
                ? "We've updated our terms. Please review the changes."
                : "Review and accept our terms to get started."
            }
          />
          <ConsentForm onAccepted={() => navigate("/overview")} />
        </div>
      </div>
    </section>
  );
};
